<template>
  <div>
    <a-modal
      :visible="modalVisible"
      class="modal-main"
      :footer="null"
      :maskClosable="false"
      @cancel="handleCloseModal"
    >
      <h1 class="modal-title">Reset Password</h1>
      <a-form layout="vertical" :model="formList" :rules="rules" ref="formList">
        <a-form-item required name="encryptPassword">
          <LineInput
            class="input-item"
            v-model:value="formList.encryptPassword"
            placeholder="New password"
            :isPassword="true"
            :visibilityToggle="true"
            :maxLength="20"
          ></LineInput>
        </a-form-item>

        <a-form-item required name="confirmPassword">
          <LineInput
            class="input-item"
            v-model:value="formList.confirmPassword"
            placeholder="Confirm password"
            :isPassword="true"
            :visibilityToggle="true"
            :maxLength="20"
          ></LineInput>
        </a-form-item>

        <div class="button" @click="handleSubmit">
          Confirm
        </div>
        <div class="cancel-button" @click="handleBackToLogin">
          Back to login
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import LineInput from '@/components/LineInput'

export default {
  name: 'ResetPasswordModal',
  components: { LineInput },
  data() {
    return {
      modalVisible: false,
      formList: {
        encryptPassword: undefined,
        confirmPassword: undefined,
      },
      rules: {
        encryptPassword: [
          {
            required: true,
            message: 'New password is required',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: 'Confirm password is required',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    showModal() {
      this.modalVisible = true
    },
    handleCloseModal() {
      this.modalVisible = false
      this.formList = {
        encryptPassword: undefined,
        confirmPassword: undefined,
      }
    },
    handleSubmit() {
      this.$refs.formList.validate().then(() => {
        this.$store.dispatch('base/ResetPassword', this.formList).then(() => {
          this.modalVisible = false
          this.$message.success(
            'Reset password successfully! You can now sign in with your new password.',
          )
        })
      })
    },
    handleBackToLogin() {
      this.modalVisible = false
      this.$emit('back-to-login')
    },
  },
}
</script>

<style></style>
